import { Model } from '@vuex-orm/core'
import requestSerializer from 'aveine-toolbox/src/store/adapter/serializer'
import { Wine } from 'aveine-toolbox'
import WineOfTheMonthTag from './wine-of-the-month-tag'

/**
 * Le coup de coeur editorial du mois (REDMINE-12962).
 *
 * Un seul par mois calendaire. La regle est portee par un index unique partiel
 * cote base : un doublon remonte donc en erreur d'ecriture, pas en 422. Une
 * suppression logique libere le mois, un choix peut etre corrige.
 */
export default class WineOfTheMonth extends Model {
  static entity = 'wines_of_the_month'

  static fields () {
    return {
      '$entity_name': this.attr(this.entity),
      'id': this.attr(null),
      // Horodatage ISO, ramene au premier jour du mois a minuit par CRUD-Wine :
      // n'importe quel jour de septembre designe septembre.
      'month': this.string(null).nullable(),
      'wine': this.belongsTo(Wine, 'wine_id'), 'wine_id': this.attr(null),
      // La prose qui justifie le coup de coeur, a ne pas confondre avec la
      // description de la fiche vin. `fr` et `en` exiges par CRUD-Wine.
      'description': this.attr({}),
      'published': this.boolean(false),
      'tags': this.hasMany(WineOfTheMonthTag, 'wine_of_the_month_id'),
      'created_at': this.string(),
      'updated_at': this.string(),
      'deleted': this.boolean(false)
    }
  }

  static readOnlyFields = ['wine_id']

  static apiConfig = {
    transformRequest: (data) => {
      if (data) {
        return requestSerializer(this.entity, data)
      } else {
        return null
      }
    }
  }
}
